import { FormBase } from 'core/components';

export default class NikoFacilityOrderExtraSuppliesAddForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'subCategoryId',
                    label: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_PLACEHOLDER',
                    rules: 'required|string'                
                },
                {
                    name: 'clinicalStatusId',
                    label: 'FACILITY_INVENTORY.FACILITY_SUPPLY.CLINICAL_STATUS.NAME',
                    placeholder: 'FACILITY_INVENTORY.FACILITY_SUPPLY.CLINICAL_STATUS.PLACEHOLDER',
                    rules: 'required|string'                
                },
                {
                    name: 'secondaryInsuranceVerified',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.INVOICE_NOTE',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_ADD_NOTE_MODAL.INVOICE_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'invoiceNote',
                    label: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INVOICE_NOTE_MODAL.INVOICE_NOTE_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.FACILITY_ORDER_TEMPLATE_INVOICE_NOTE_MODAL.INVOICE_NOTE_PLACEHOLDER',
                    rules: 'string'
                },
            ],
        };
    }
}
